/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilityFindingsTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraVulnerabilityFindingsTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraVulnerabilityFindingsTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilityFindingsTypeQueryOperator>): InfraVulnerabilityFindingsTypeQueryOperator {
        let obj = Object.assign(new InfraVulnerabilityFindingsTypeQueryOperator(), model);
        InfraVulnerabilityFindingsTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilityFindingsTypeQueryOperator>): InfraVulnerabilityFindingsTypeQueryOperator {
        if (!model) return null;
        return InfraVulnerabilityFindingsTypeQueryOperator.newInstance(<InfraVulnerabilityFindingsTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilityFindingsTypeQueryOperator) {
        if (!obj) return;

        models.InfraVulnerabilityFindingsTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilityFindingsTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilityFindingsTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches against the start of the findings type
     */
    starts_with: string;

}
